module.exports = __webpack_public_path__ + "@/assets/img/emailFooter.f6302f0d.jpg";